export default (d: string | Date) => {
    const date = new Date(d);
    return date instanceof Date && !Number.isNaN(+date);
};
